import { Modal } from "components";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import React, { useState } from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { getRequiredTranslationValueFieldsForNew, useTranslationValuesForNewState } from "webform/components/TranslationValueInnerForm";

interface Props {
  mainArea: server.dto.MainAreas;
  isOpen: boolean;
  onClose: () => void;
}

interface NewFreeFieldCategoryFormState {
  title: server.dto.TranslationValue[]
}

export const NewFreeFieldCategoryModal = (props: Props) => {
  const [formState, setFormState] = useState<NewFreeFieldCategoryFormState>({
    title: [],
  });

  const titleState = useTranslationValuesForNewState(formState.title, (title) => setFormState((state) => ({ ...state, title })));

  const submit = () => {
    return window.CoreApi.FreeFieldCategory.Create({
      mainArea: props.mainArea,
      title: formState.title,
    })
  }

  const onSuccess = async (freeFieldCategoryId: number) => {
    window.location.href = routes.freeFieldCategory_Detail(freeFieldCategoryId).absolute;
  }

  return <Modal
    isOpen={props.isOpen}
    title={RESX.FreeField.FreeFieldCategory}
    handleClose={props.onClose}
    width="tiny"
  >
    <div className="grow1 scrollbox-auto">
      <EditSectionTemplate
        submit={submit}
        noPanels
        onSuccess={onSuccess}
        sections={[{
          key: "newFreeFieldCategory",
          type: "regular",
          title: RESX.FreeField.FreeFieldCategory,
          fields: getRequiredTranslationValueFieldsForNew("title", titleState),
        }]}
      />
    </div>
  </Modal>
}